export default [
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/authen/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/new-password/:username/:token/:phone/:otp',
    name: 'auth-loginfor',
    component: () => import('@/views/authen/Loginfor.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/register-phone',
    name: 'auth-register-phone',
    component: () => import('@/views/authen/RegisterPhone.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'auth-forgot-password',
    component: () => import('@/views/authen/RegisterPhoneFor.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/verify-otp/:phone',
    name: 'auth-verify-otp',
    component: () => import('@/views/authen/VerifyOTP.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/verify-otp-password/:phone',
    name: 'auth-verify-otp-password',
    component: () => import('@/views/authen/VerifyOTPfor.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/register/:phone',
    name: 'auth-register',
    component: () => import('@/views/authen/Register.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/register-shop/:phone/:email',
    name: 'auth-register-shop',
    component: () => import('@/views/authen/RegisterShop.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
     
    },
  },
  {
    path: '/register-payment',
    name: 'auth-register-payment',
    component: () => import('@/views/authen/RegisterPayment.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'auth-forgot-password',
    component: () => import('@/views/authen/ForgotPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/reset-password',
    name: 'auth-reset-password',
    component: () => import('@/views/authen/ResetPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
]
